const subscriptionPlans = {
  valueMustBeInteger: "Value must be an integer",
  WillBeDeletedAfterSaving: "Will be deleted after saving",
  SaveChanges: "Save Changes",
  YouAreAboutToSaveChanges:
    "You are about to save {{count}} change{{count > 1 ? 's' : ''}}. Here's what will be applied:",
  NewPlans: "New Plans",
  UpdatedPlans: "Updated Plans",
  DeletedPlans: "Deleted Plans",
  Cancel: "Cancel",
  Confirm: "Confirm",
  ThisActionCannotBeUndone:
    "This action cannot be undone. Please review your changes carefully.",
  planName: "Plan name",
  plan: "Plan {{index}}",
  choosePlanName: "Choose a plan name",
  custom: "Custom",
  planNameInEnglish: "Plan name in English",
  planNameInArabic: "Plan name in Arabic",
  planNamesMustBeDifferent:
    "Plan name must be different in English and Arabic",
  planTitleAlreadyExists:
    "A plan with this name already exists. Please choose a different name.",
  choosePlanIcon: "Choose plan icon",
  addCustomName: "Add custom name",
  createCustomPlanName: "Create custom plan name",
  create: "Create",
  change: "Change",
  emoji: "Emoji",
  chooseSubscriptionImage: "Choose subscription image",
  chooseSubscriptionImageDescription:
    "Select a cover image for your subscription plans, or upload a custom one.",
  cropImage: "Crop image",
  cropAndSave: "Crop & Save",
  saving: "Saving…",
  deleteCover: "Delete cover image",
  uploadImage: "Upload image",
  uploadImageHint: "PNG, JPG, GIF up to 4MB",
  foodImage: "Food image",
  coffeeImage: "Coffee image",
  fileTooSmall: "Image must be at least 4KB",
  fileTooLarge: "Image must be at most 4MB",
  imageProcessingError: "Failed to process image. Please try again.",
  unsupportedFileType: "Please upload a PNG, JPG or GIF image",
  usersPay: "Users pay",
  usersReceive: "Users receive",
  bonusPercentage: "Bonus percentage",
  addNewPlan: "Add new plan",
  save: "Save",
  allowMonthlySubscriptionPlans: "Allow monthly subscription plans",
  allowMonthlySubscriptionPlansDescription:
    "Users receive bonus wallet credit when they subscribe to\na monthly plan. If they choose for the plan not to expire,\nextra credit will be removed.",
  amountCannotExceed: "Amount cannot exceed {{amount}}",
  percentageCannotExceed: "Percentage cannot exceed 100%",
  priceMustBeGreaterThan0: "Price must be greater than 0",
  required: "Required",
  amountAfterBonusCannotBeZero: "Amount must be greater than 0",
  amountAfterBonusMustBeAtLeastPlanPrice: "Amount after bonus must be at least {{planPrice}}"
};

export default subscriptionPlans;
